module.exports = __webpack_public_path__ + "img/jx5.6ebb4af7.png";